export interface LogbookOffset {
  name: string;
  offset: number;
}

export const logbookOffsets: LogbookOffset[] = [
  {
    name: 'UTC-12',
    offset: -43200000,
  },
  {
    name: 'UTC-11',
    offset: -39600000,
  },
  {
    name: 'UTC-10',
    offset: -36000000,
  },
  {
    name: 'UTC-9:30',
    offset: -34200000,
  },
  {
    name: 'UTC-9',
    offset: -32400000,
  },
  {
    name: 'UTC-8',
    offset: -28800000,
  },
  {
    name: 'UTC-7',
    offset: -25200000,
  },
  {
    name: 'UTC-6',
    offset: -21600000,
  },
  {
    name: 'UTC-5',
    offset: -18000000,
  },
  {
    name: 'UTC-4:30',
    offset: -16200000,
  },
  {
    name: 'UTC-4',
    offset: -14400000,
  },
  {
    name: 'UTC-3:30',
    offset: -12600000,
  },
  {
    name: 'UTC-3',
    offset: -10800000,
  },
  {
    name: 'UTC-2:30',
    offset: -9000000,
  },
  {
    name: 'UTC-2',
    offset: -7200000,
  },
  {
    name: 'UTC-1',
    offset: -3600000,
  },
  {
    name: 'UTC',
    offset: 0,
  },
  {
    name: 'UTC+1',
    offset: 3600000,
  },
  {
    name: 'UTC+2',
    offset: 7200000,
  },
  {
    name: 'UTC+3',
    offset: 10800000,
  },
  {
    name: 'UTC+3:30',
    offset: 12600000,
  },
  {
    name: 'UTC+4',
    offset: 14400000,
  },
  {
    name: 'UTC+4:30',
    offset: 16200000,
  },
  {
    name: 'UTC+5',
    offset: 18000000,
  },
  {
    name: 'UTC+5:30',
    offset: 19800000,
  },
  {
    name: 'UTC+6',
    offset: 21600000,
  },
  {
    name: 'UTC+6:30',
    offset: 23400000,
  },
  {
    name: 'UTC+7',
    offset: 25200000,
  },
  {
    name: 'UTC+8',
    offset: 28800000,
  },
  {
    name: 'UTC+8:45',
    offset: 31680000,
  },
  {
    name: 'UTC+9',
    offset: 32400000,
  },
  {
    name: 'UTC+9:30',
    offset: 34200000,
  },
  {
    name: 'UTC+10',
    offset: 36000000,
  },
  {
    name: 'UTC+10:30',
    offset: 37800000,
  },
  {
    name: 'UTC+11',
    offset: 39600000,
  },
  {
    name: 'UTC+11:30',
    offset: 41400000,
  },
  {
    name: 'UTC+12',
    offset: 43200000,
  },
  {
    name: 'UTC+13',
    offset: 46800000,
  },
  {
    name: 'UTC+13:45',
    offset: 49680000,
  },
  {
    name: 'UTC+14',
    offset: 50400000,
  },
];
